module.exports = __webpack_public_path__ + "static/media/guide_2.d26c0664.svg";